import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Dimmer,
  Label,
} from 'semantic-ui-react';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import LoadImage from './LoadImage';

class PictureItem extends Component {
  static propTypes = {
    t: PropTypes.func,
    picture: PropTypes.shape({
      key: PropTypes.string,
      tags: PropTypes.arrayOf(
        PropTypes.string,
      ),
    }),
    labelNode: PropTypes.node,
    buttonNode: PropTypes.node,
    hideTags: PropTypes.bool,
    onViewLarge: PropTypes.func,
    onRemove: PropTypes.func,
    size: PropTypes.string,
    pictureSize: PropTypes.number,
    onTagClick: PropTypes.func,
    extension: PropTypes.oneOf([
      'jpg', 'jpeg', 'png', 'gif', 'pdf',
    ]),
    fixedSize: PropTypes.bool,
  }
  static defaultProps = {
    fixedSize: null,
  }
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }
  handleShowDimmed = () => {
    this.setState({ active: true });
  }
  handleHideDimmed = () => {
    this.setState({ active: false });
  }
  handleTagClick = (tag) => {
    if (this.props.onTagClick) {
      this.props.onTagClick(tag);
    }
  }
  render() {
    const { t } = this.props;
    const { active } = this.state;
    return (
      <Card className={this.props.fixedSize ? 'picture-item-fixed-size' : 'picture-item'}>
        <Dimmer.Dimmable
          dimmed={active}
          className="center"
          onMouseEnter={() => this.handleShowDimmed()}
          onMouseLeave={this.handleHideDimmed}
        >
          <Dimmer style={{ zIndex: 20 }} active={active}>
            {
              this.props.onViewLarge ?
                <Button
                  primary
                  icon="zoom"
                  content={t('View', { ns: TRANSLATION_FILES.translation })}
                  onClick={e => this.props.onViewLarge(e)}
                />
              : null
            }
            {
              this.props.onRemove ?
                <Label
                  as="a"
                  corner
                  color="red"
                  icon="close"
                  onClick={e => this.props.onRemove(e)}
                />
              : null
            }
          </Dimmer>
          <LoadImage
            centered
            asBackground={this.props.fixedSize}
            size={this.props.size}
            picture={this.props.picture}
            pictureSize={this.props.pictureSize}
            labelNode={this.props.labelNode}
            extension={this.props.extension}
          />
        </Dimmer.Dimmable>
        {
          this.props.hideTags ?
          null :
          <Card.Content>
            <Label.Group size="tiny">
              {
                this.props.picture.tags && this.props.picture.tags.length > 0 ?
                this.props.picture.tags.map((tag, idx) => (
                  <Label key={idx} as="a" onClick={() => this.handleTagClick(tag)}>{tag}</Label>
                ))
                : <Card.Meta>{t('No tags set', { ns: TRANSLATION_FILES.translation })}</Card.Meta>
              }
            </Label.Group>
          </Card.Content>
        }
        {this.props.buttonNode}
      </Card>
    );
  }
}

export default withTranslation(namespaces)(PictureItem);



// WEBPACK FOOTER //
// ./src/components/PictureItem.jsx